import { CLEAR_FAVORITE_FILES, FETCH_FAVORITE_FILES, SET_FAVORITE_FILES } from "../actions";

export const getFavoriteFiles = () => ({
    type: FETCH_FAVORITE_FILES,
});

export const setFavoriteFiles = (favoriteFiles) => ({
    type: SET_FAVORITE_FILES,
    payload: favoriteFiles,
});

export const clearFavoriteFiles = () => ({
    type: CLEAR_FAVORITE_FILES,
});
